// Regras do anexo de CNH no front (issue #324).
//
// Funções puras, sem React: o anexo pode ser imagem OU PDF, e as duas telas
// que o exibem (efetivo/Perfil e o modal de efetivo/Editar) precisam da mesma
// decisão. A lista de formatos e o teto espelham
// virgem/src/app/utils/validaArquivoCnh.js — divergir aqui só troca um erro
// imediato na tela por um 400 depois do upload ter subido.
//
// O que não é específico da CNH (ler o BLOB, detectar PDF, virar Blob) mora em
// utils/arquivoDataUrl.js e é reexportado aqui por conveniência de quem já
// importava daqui.
export { paraDataUrl, ehPdf, dataUrlParaBlob } from '../../utils/arquivoDataUrl';

export const LIMITE_BYTES = 5 * 1024 * 1024;

export const MIMES_ACEITOS = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'application/pdf',
];

// Devolve string[] de mensagens prontas para o toast. Array vazio = pode subir.
//
// O teto vale para PDF, que sobe como veio. Imagem passa antes pelo Compressor,
// entao o tamanho que importa e o de DEPOIS — barrar pelo original recusaria
// foto de celular de 8 MB que sairia da compressao com ~1 MB.
export const aceitaUpload = arquivo => {
  if (!arquivo) return ['Selecione um arquivo.'];

  if (!MIMES_ACEITOS.includes(arquivo.type)) {
    return ['Formato não aceito. Envie PNG, JPG ou PDF.'];
  }

  if (arquivo.type === 'application/pdf' && arquivo.size > LIMITE_BYTES) {
    return ['Arquivo acima do limite de 5 MB.'];
  }

  return [];
};

// Zoom do visualizador. O piso é 1 (imagem inteira na tela); abaixo disso só
// sobraria moldura, e no celular a pessoa perde a referência do que está vendo.
export const ZOOM_MAX = 6;

export const proximoZoom = (atual, fator) =>
  Math.min(ZOOM_MAX, Math.max(1, atual * fator));
